module.exports = __webpack_public_path__ + "static/media/Cartel_Empresas-2022_.1483106f.jpeg";